module.exports = __webpack_public_path__ + "static/assets/ca4e1d756a09cf9e75b48df72cc558ce.png";